var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemovebookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 16.5 5 C 12.916 5 10 7.916 10 11.5 L 10 41.5 C 10 42.063 10.315406 42.579938 10.816406 42.835938 C 11.317406 43.091938 11.919953 43.045797 12.376953 42.716797 L 22.039062 35.759766 C 22.024062 35.506766 22 35.257 22 35 C 22 33.891 22.155969 32.820016 22.417969 31.791016 L 13 38.572266 L 13 11.5 C 13 9.57 14.57 8 16.5 8 L 31.5 8 C 33.43 8 35 9.57 35 11.5 L 35 22 C 36.034 22 37.035 22.134281 38 22.363281 L 38 11.5 C 38 7.916 35.084 5 31.5 5 L 16.5 5 z M 35 24 C 28.925 24 24 28.925 24 35 C 24 41.075 28.925 46 35 46 C 41.075 46 46 41.075 46 35 C 46 28.925 41.075 24 35 24 z M 28 34 L 42 34 C 42.552 34 43 34.448 43 35 C 43 35.552 42.552 36 42 36 L 28 36 C 27.448 36 27 35.552 27 35 C 27 34.448 27.448 34 28 34 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovebookmark);
export default __webpack_public_path__ + "static/media/removebookmark.a716ddc674031dbdaf636c920fa4bad6.svg";
export { ForwardRef as ReactComponent };